import { ILesson } from './lesson';

export enum enCourseType {
  course = 1,
  package = 2
}
export enum enStatus {
  PRODUCER = 'producer',
  LEARNER = 'learner',
  FREE = 'free',
  SOMETHING_FREE = 'something_free',
  MUST_ACCEPT_TERM = 'must_accept_term',
  NOT_RELEASED = 'not_released',
  EXPIRED = 'expired',
  BLOCKED = 'blocked',
  OFFER = 'offer',
  NOT_PURCHASED = 'not_purchased'
}

export interface IMyCourse {
  id: number;
  title: string;
  hash: string;
  progress_percent?: number;
  image: string;
  old_image: string;
  lessons_default_image?: string;
  course_newcard_background?: string;
  author: IAuthor;
  total_lessons: number;
  total_modules: number;
  description: string;
  last_lesson_access: number;
  status: enStatus;
  release_at: string;
  expire_at: string;
}

export interface IKeepLearningCourse extends Omit<IMyCourse, 'last_lesson_access'> {
  lesson_id: number;
}
export interface ICourseShelf {
  id: number;
  hash: string;
  title: string;
  modules: ICourseShelfModule[];
  portal: {
    subdomain: string | null;
    name: string | null;
  };
}

export type ICourseShelfModule = {
  total_lessons: number;
  id: number;
  title: string;
  banner: string;
};

export interface IAuthor {
  id: number;
  name: string;
  avatar: string;
  description: string;
}

export interface ICourse extends Omit<IMyCourse, 'total_modules'> {
  author: IAuthor;
  certificate_url: string;
  progress_bar: boolean;
  expire_at: string;
  is_free: boolean;
  blocked_by: enStatus;
  offer: number;
  access_type: number;
  producer: IProducer;
  offer_url: string;
  has_certificate: boolean;
  terms_content: string;
  fc_pixel?: string;
  customizations: {
    image_cover?: string;
    lessons_default_image?: string;
    course_newcard_background?: string;
  };
  secretary_status: boolean;
  depoimentu_url: string;
  secretary_url: string;
  have_active_community: boolean;
  disable_talk_to_producer?: boolean;
}
export interface IProducer {
  id: number;
  id_leg: number;
  name: string;
  email: string;
  business_name: string;
  avatar?: string;
  clicodEduzz?: number;
}
export interface IModule {
  id: number;
  title: string;
  status: enStatus;
  release: string;
  total_lessons: number;
  lessons: ILesson[];
}
export const allowedStatus = [
  enStatus.LEARNER,
  enStatus.PRODUCER,
  enStatus.FREE,
  enStatus.MUST_ACCEPT_TERM,
  enStatus.NOT_RELEASED
];

export const blockedStatus = [enStatus.BLOCKED, enStatus.EXPIRED, enStatus.NOT_RELEASED, enStatus.MUST_ACCEPT_TERM];
